import dayjs from "dayjs";

const dateFormat = (val: string | Date, format = "YY.MM.DD HH:mm:ss") =>
  dayjs(val).format(format);

export { dateFormat };
